import { render, staticRenderFns } from "./NewDraftContract.vue?vue&type=template&id=4b69657c"
import script from "./NewDraftContract.vue?vue&type=script&lang=js"
export * from "./NewDraftContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports